import React, { Component } from 'react';
import Fab from '@material-ui/core/Fab';
import Icon from '@material-ui/core/Icon';

class BackToTop extends Component {
  constructor(props){
    super(props);

    this.state = {
      isVisible: false
    }

    this.floatRight = {
      color: 'white',
      backgroundColor: 'rgba(0,0,0,0.7)',
      margin: 0,
      top: 'auto',
      right: 20,
      bottom: 20,
      position: 'fixed',
      outline: 'none',
      visibility: 'hidden',
      opacity: 0,
      transition: 'all 0.3s'
    }

    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleScroll);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    this.setState({ isVisible: window.scrollY > 100 })
  }

  render(){
    const { isVisible } = this.state;

    if(isVisible){
      this.floatRight = {...this.floatRight, visibility:"visible", opacity: 1}
    }else{
      this.floatRight = {...this.floatRight, visibility:"hidden", opacity: 0}
    }

    return(
          <Fab style={this.floatRight} aria-label="Add" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}>
            <Icon className="fas fa-chevron-up"/>
          </Fab>
    );
  }
}

export default BackToTop;
